module.exports = `fragment product_panel on Contentstack_product_panel {
    json
    name
    panel_id
    global_id
  }`;